import { render } from "./MetadataPanel.vue?vue&type=template&id=b21c61f2&scoped=true"
import script from "./MetadataPanel.vue?vue&type=script&lang=js"
export * from "./MetadataPanel.vue?vue&type=script&lang=js"

import "./MetadataPanel.vue?vue&type=style&index=0&id=b21c61f2&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21c61f2"]])

export default __exports__